import { Box, NumberInput, NumberInputProps } from '@mantine/core';

import InputLabel from 'components/input-label';
import classes from './index.module.css';

export const DECIMAL_PROPS = {
  allowDecimal: true,
  decimalScale: 2,
};

interface ICustomNumberInput extends NumberInputProps {
  info?: string;
  label?: string;
  variant?: string;
  labelLight?: boolean;
}

const CustomNumberInput = ({
  info,
  label,
  required,
  variant = '',
  labelLight = false,
  ...props
}: ICustomNumberInput) => (
  <Box>
    {label ? <InputLabel label={label} light={labelLight} required={required} info={info} /> : undefined}
    <NumberInput
      classNames={{ wrapper: classes.wrapper, input: `${classes.input} ${classes[variant]}` }}
      mb={6}
      withAsterisk={required}
      {...props}
    />
  </Box>
)

export default CustomNumberInput;